import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Header, Icon, List, Segment, Statistic } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const INITIAL_STATE = {
  loading: false,
  data: [],
  error: null
};

class SimpleList extends Component {

  constructor (props) {
    super(props);

    this.state = INITIAL_STATE;
  }

  static propTypes = {
    service: PropTypes.object.isRequired,
    findParams: PropTypes.object,
    mappingFunc: PropTypes.func.isRequired,
    headerButton: PropTypes.shape({
      content: PropTypes.string,
      icon: PropTypes.string,
      to: PropTypes.string
    }),
    expandLink: PropTypes.string,
    statisticLabel: PropTypes.string,
    statisticValue: PropTypes.oneOf(PropTypes.string, PropTypes.number)
  }

  static defaultProps = {
    findParams: {}
  }

  componentDidMount () {
    this.findRecords();
  }

  findRecords = () => {
    this.setState({
      loading: true,
      data: [],
      error: null
    });

    this.props.service.find(this.props.findParams)
      .then(response => {
        console.log(response);
        this.setState({
          loading: false,
          data: response.data
        });
      })
      .catch(error => {
        this.setState({
          loading: false,
          error: error
        });
      });
  }

  render () {
    const {
      loading,
      data
    } = this.state;

    const renderBody = () => {
      if (loading) {
        return (
          <Header textAlign="center" style={{ marginBottom: 0 }}>
            Cargando
          </Header>
        );
      } else if (data && data.length === 0) {
        return (
          <Header icon textAlign="center" style={{ marginBottom: 0 }}>
            <Icon name="frown" />
            Lista Vacia
            <Header.Subheader>
              No se encontraron registros
            </Header.Subheader>
          </Header>
        );
      } else {
        return (
          <List divided relaxed>
            {
              data && data.map(this.props.mappingFunc).map((item, index) => (
                <List.Item key={index}>
                  {
                    item.floatedContent &&
                      <List.Content floated="right">
                        <List.Header as="a">
                          <span style={{ color: item.floatedContentColor || 'black' }}>{item.floatedContent}</span>
                        </List.Header>
                      </List.Content>
                  }
                  <List.Icon color={item.iconColor || 'black'} name={item.icon || 'help'} size="large" verticalAlign="middle" />
                  <List.Content>
                    {
                      item.link ?
                        <List.Header as={Link} to={item.link}>{item.header}</List.Header> :
                        <List.Header>{item.header}</List.Header>
                    }
                    <List.Description>{item.description}</List.Description>
                  </List.Content>
                </List.Item>
              ))
            }
          </List>
        );
      }
    };

    const renderFooter = () => {
      if (this.props.expandLink && this.props.refreshButton) {
        return (
          <Button.Group fluid size="tiny">
            <Button content="Refrescar" icon="refresh" onClick={this.findRecords} positive />
            <Button.Or text="-" />
            <Button as={Link} content="Ver Mas" icon="ellipsis horizontal" primary to={this.props.expandLink} />
          </Button.Group>
        );
      } else if (this.props.refreshButton) {
        return (
          <Button content="Refrescar" fluid icon="refresh" onClick={this.findRecords} positive />
        );
      } else if (this.props.expandLink) {
        return (
          <Link to={this.props.expandLink}><strong>Ver Mas</strong></Link>
        );
      }
    };

    let elements = [
      <Header attached="top" as="h4" inverted style={{ backgroundColor: '#2185D0' }} key={'header'}>
        {
          this.props.headerButton &&
          <Button
            as={Link} icon={this.props.headerButton.icon}
            floated="right" content={this.props.headerButton.content}
            positive to={this.props.headerButton.to} />
        }
        <Header.Content>
          {this.props.header}
          <Header.Subheader>
            {this.props.subheader}
          </Header.Subheader>
        </Header.Content>
      </Header>
    ];

    if (this.props.statisticLabel || this.props.statisticValue) {
      elements.push(
        <Header attached textAlign="center" key={'statistic'}>
          <Statistic label={this.props.statisticLabel} size="tiny" value={this.props.statisticValue} />
        </Header>
      );
    }

    elements.push(
      <Segment attached color="blue" key={'body'} loading={loading}>
        {renderBody()}
      </Segment>
    );

    elements.push(
      <Segment attached="bottom" clearing key={'footer'} textAlign="center" vertical={this.props.expandLink && !this.props.refreshButton}>
        {renderFooter()}
      </Segment>
    );

    return elements;
  }

}

export default SimpleList;


// WEBPACK FOOTER //
// ./src/components/lists/SimpleList.jsx